<template>
    <v-card>
        <v-toolbar v-if="!this.clockOutView" color="primary" dark>
            <v-toolbar-title class="dialog-toolbar">
                Employees On Job
            </v-toolbar-title>
        </v-toolbar>
        <v-toolbar v-else color="error" dark>
            <v-toolbar-title class="dialog-toolbar">
                Employee: {{ this.selectedEmployee.Name }}
            </v-toolbar-title>
        </v-toolbar>
        <v-card-text v-if="!this.clockOutView">
            <v-row>
                <v-col cols="2">
                    <template v-for="item in jobDtl">
                        <v-row class="onJobHeader">{{ item.header }}</v-row>
                        <v-row style="font-size: 2em">{{ item.info }}</v-row>
                    </template>
                </v-col>
                <v-col cols="3">
                    <v-card variant="outlined" rounded height="400">
                        <v-list>
                            <v-list-item
                                class="py-2 text-center"
                                v-for="user in allActiveUsers"
                                :key="user.EmployeeNum"
                                @click="selectEmployee(user)"
                                :active="selectedEmployee === user"
                                active-class="employeeSelected"
                            >
                                <v-list-item-title
                                    class="mb-1"
                                    style="font-size: 2em"
                                >
                                    <v-icon v-if="selectedEmployee === user">
                                        <i class="mdi mdi-account-check"></i>
                                    </v-icon>
                                    {{ user.Name }}
                                </v-list-item-title>
                                <v-list-item-subtitle
                                    class="mb-1"
                                    style="font-size: 1.25em"
                                    >{{
                                        user.ClockInDate +
                                        "   " +
                                        user.ClockInTime +
                                        " (" +
                                        user.EmployeeNum +
                                        ")"
                                    }}
                                </v-list-item-subtitle>

                                <v-divider></v-divider>
                            </v-list-item>
                        </v-list>
                    </v-card>
                </v-col>
                <v-col>
                    <v-row>
                        <v-btn
                            color="primary"
                            @click="this.clockOutView = true"
                            class="custom-large-btn my-10 ml-10"
                            variant="elevated"
                            :disabled="this.selectedEmployee === null"
                        >
                            <span class="button-text">Next</span>
                        </v-btn>
                    </v-row>
                    <v-row>
                        <v-btn
                            color="error"
                            @click="closeManagerPunchScreen"
                            class="custom-large-btn mt-10 ml-10"
                            variant="elevated"
                        >
                            <span class="button-text">Exit</span>
                        </v-btn>
                    </v-row>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-text v-else>
            <QuantityEntry
                :punchName="selectedEmployee.Name"
                :jobInfo="jobInfo"
                :managerPunch="true"
                :punchID="selectedEmployee.EmployeeNum"
                @clockOutDetails="getClockOutDetails"
                @clockOutJob="clockOutJob"
                @closeManagerPunchScreen="closeManagerPunchScreen"
            >
            </QuantityEntry>
        </v-card-text>
    </v-card>
</template>

<script>
import axios from "axios";
import QuantityEntry from "./QuantityEntry.vue";

export default {
    name: "ClockOut",
    emits: ["closeManagerPunchScreen", "clockOutJob", "clockOutDetails"],
    components: { QuantityEntry },
    props: {
        jobInfo: {
            type: Object,
            default: null,
        },
        rowID: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            clockOutView: false,
            selectedEmployee: null,
            allActiveUsers: [],
            clockOutDetails: [],
            jobDtl: [
                { header: "Job Number", info: this.jobInfo.JobNum },
                { header: "Assembly Seq", info: this.jobInfo.AsmSeq },
                { header: "Operation Seq", info: this.jobInfo.OprSeq },
            ],
        };
    },
    mounted() {
        this.getAllUsers();
    },
    watch: {},
    computed: {
        deptTitle() {
            let path = window.location.pathname;
            let regex = /\/labor-(\w+)\/\w+/;
            let match = path.match(regex);

            if (match && match[1]) {
                return match[1];
            }
        },

        resourceId() {
            let path = window.location.pathname;
            let regex = /\/labor-\w+\/(\w+)/;
            let match = path.match(regex);

            if (match && match[1]) {
                return match[1];
            }
        },
    },
    methods: {
        async getAllUsers() {
            try {
                await axios
                    .get(
                        route("legacy-api.getAllActiveUsers", {
                            SysRowID: this.rowID, // "BE7DAF30-8A8C-46A2-AA75-43B9D0B0670B"
                            ResourceGrp: this.deptTitle,
                        })
                    )
                    .then((response) => {
                        this.allActiveUsers = response.data;
                    });
            } catch (err) {
                console.log(err);
            }
        },
        clockOutJob() {
            this.$emit("clockOutJob");
        },
        closeManagerPunchScreen() {
            this.$emit("closeManagerPunchScreen");
        },
        selectEmployee(user) {
            this.selectedEmployee = user;
        },
        getClockOutDetails(dtl) {
            this.clockOutDetails = dtl;
            this.sendClockOutDetails();
        },
        sendClockOutDetails() {
            this.$emit("clockOutDetails", this.clockOutDetails);
        },
    },
};
</script>

<style scoped>
.employeeSelected {
    background: lightgreen !important;
}

.dialog-toolbar {
    font-size: 2em;
    line-height: 1.2;
}

.onJobHeader {
    font-size: 1.25em;
    text-decoration: underline;
    font-weight: 900;
}

.custom-large-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 32px;
    padding: 60px 60px;
    width: 20%;
}

.button-text {
    display: inline-block;
}
</style>
